export default {
    data() {
        return {
        }
    },
    mounted() {
        if(typeof(this.$gtag) !== 'undefined') {
            this.$gtag.purchase({
                "transaction_id": this.order?.reference ? this.order.reference : '',
                "affiliation": this.webName ? this.webName : '',
                "value": this.order?.total ?? 0.00,
                "currency": "GBP",
                "tax": this.order?.tax ?? 0.00,
                "coupon": this.order?.discount_codes ? this.order.discount_codes : '',
                "shipping": this.order?.delivery_amount ?? 0.00,
                "items": this.purchasedItems
            });
            console.log('success purchase tracking.');
        }
        else {
            console.log('gtag not loaded');
        }

        // PriceShape API (Send Sale)
        window.PRICESHAPE = window.PRICESHAPE || [];
        _.forEach(this.order?.products, function(product, key) {
            if(product.product_type === 'product') {
                window.PRICESHAPE.itemsSold([
                    { upi: String(product.st_code), itemsSold: product.quantity, uniqueSales: 1},
                ])
            }
        });
    },
    methods: {
        trackFailure() {
            
        }
    },
    computed: {
        purchasedItems() {
            var products = [];
            let vm = this;

            _.forEach(this.order?.products, function(product, key) {
                products.push({
                    'item_id': product.id,
                    'item_name': product.tyre_description,
                    'item_brand': product.brand,
                    'quantity': product.quantity,
                    'price': product.retail,
                    'coupon': vm.order?.discount_codes ? vm.order.discount_codes : ''
                });
            });

            if(this.order?.mobile_fitting_amount > 0.00) {
                products.push({
                    'item_id': 'MF',
                    'item_name': 'Mobile Fitting',
                    'quantity': 1,
                    'price': this.order?.mobile_fitting_amount,
                });
            }

            return products;
        }
    }
};